import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';

import { reportWebVital } from './errors';

/**
 * LCP / INP / CLS / TTFB / FCP through the same channel as errors, under a
 * `metric_type: "web_vital"` discriminator, **sampled at 100%** — the operator
 * population is small enough that sampling would produce noise rather than
 * signal.
 */
export function installWebVitals(): void {
  onLCP((metric) => reportWebVital(metric.name, metric.value));
  onINP((metric) => reportWebVital(metric.name, metric.value));
  onCLS((metric) => reportWebVital(metric.name, metric.value));
  onTTFB((metric) => reportWebVital(metric.name, metric.value));
  onFCP((metric) => reportWebVital(metric.name, metric.value));
}
